var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5.25C11.875 5.25 12 5.375 12 5.5V6.5C12 6.65625 11.875 6.75 11.75 6.75H6.75V11.75C6.75 11.9062 6.625 12 6.5 12H5.5C5.34375 12 5.25 11.9062 5.25 11.75V6.75H0.25C0.09375 6.75 0 6.65625 0 6.5V5.5C0 5.375 0.09375 5.25 0.25 5.25H5.25V0.25C5.25 0.125 5.34375 0 5.5 0H6.5C6.625 0 6.75 0.125 6.75 0.25V5.25H11.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.000b4a6359b4eb760893fb08b8c7ce3c.svg";
export { ForwardRef as ReactComponent };